import { ClassnameAwareComponentProps } from '../types';
import { Checkbox } from '@mui/material';
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';

interface Props extends ClassnameAwareComponentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function MarketingSubscriptionConsent({ checked, onChange, className }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Marketing:MarketingSubscriptionConsent' });

  const { profile } = useSelector((state: StoreInterface) => state.profile);

  return (
    profile &&
    !profile.is_marketing_subscriber && (
      <div className={classnames('flex', className)}>
        <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)} id="is_marketing_subscriber" />
        <label htmlFor="is_marketing_subscriber" className="ml-2xs my-auto text-sm">
          {t('title')}
        </label>
      </div>
    )
  );
}
